import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Service from './Service.js';
import { getRaf, getCancelRaf } from '../utils/nextFrame.js';

class Raf extends Service {
  constructor() {
    super();

    _defineProperty(this, "isTicking", false);

    _defineProperty(this, "id", 0);

    _defineProperty(this, "raf", getRaf());

    _defineProperty(this, "cancelRaf", getCancelRaf());

    this.loop = this.loop.bind(this);
  }

  init() {
    this.isTicking = true;
    this.loop();
    return this;
  }

  loop() {
    this.trigger(this.props);

    if (!this.isTicking) {
      return;
    }

    this.id = this.raf(this.loop);
  }

  kill() {
    this.cancelRaf(this.id);
    this.isTicking = false;
    return this;
  }

  get props() {
    return {
      time: window.performance.now()
    };
  }

}

var instance = null;
export default function useRaf() {
  if (!instance) {
    instance = new Raf();
  }

  var add = instance.add.bind(instance);
  var remove = instance.remove.bind(instance);
  var has = instance.has.bind(instance);

  function props() {
    return instance.props;
  }

  return {
    add,
    remove,
    has,
    props
  };
}